import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import axios from "axios";
import Swal from 'sweetalert2';
import CustomTable from '../../helpers/custom-table'
import { catchError } from '../../helpers/catch-error-case-manager';
import { NavLink } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';


const Closed = () => {
  const navigate = useNavigate();

  
  var columns = React.useMemo(
    () => [
      {
        accessorFn: row => <a href={"/case-manager/work-order/" + row.work_order_id} >{row.work_order_no}</a>,
        id: "work_order_id",
        cell: info => info.getValue(),
        header: () => "ID",
        footer: props => props.column.id,
        enableColumnFilter: false,
      },
      {
        accessorKey: "close_date",
        header: () => "Close Date",
        footer: props => props.column.id
      },
      {
        accessorFn: row => row.patient_last_name + " " + row.patient_first_name,
        id: "lastName",
        cell: info => info.getValue(),
        header: () => "Patient Name",
        footer: props => props.column.id
      },
      {
        accessorKey: "closed_by",
        header: "Closed By",
        footer: props => props.column.id
      },
      {
        accessorFn: row => <>
          <a onClick={() => copyWorkOrder(row.work_order_id)} href="javascript:void(0)" className="btn btn-link ">Copy</a>
               
        </>,
        id: "actions",
        cell: info => info.getValue(),
        header: () => "ACTIONS",
        footer: props => props.column.id,
        enableColumnFilter: false,
        enableSorting: false,
      }


    ],
    []
  )


  const [data, setData] = React.useState(null);

  const getWorkOrders = async () => {

    await axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/case-manager/get-closed-work-orders", {
      withCredentials: true
    })
      .then(function (response) {

        if (response?.data?.status) {

          setData(response?.data?.work_orders);

        } else {


          Swal.fire({ icon: "error", title: "Pending Admin Action Work Order Failed to Load", text: response?.data?.message });

        }

      })
      .catch(function (error) {

        catchError(error,navigate)

      });

  }



const copyWorkOrder = async (work_order_id) => {

  await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/case-manager/copy-work-order", {
    work_order_id: work_order_id
  }, {
    withCredentials: true
  })
    .then(function (response) {

      if (response?.data?.status) {

        getWorkOrders();
        Swal.fire({ icon: "success", title: "Work order copied successfully. " });


      } else {

        Swal.fire({ icon: "error", title: "Unable to copy work order " });

      }

    })
    .catch(function (error) {

      catchError(error,navigate)

    });


}

  useEffect(() => {

    getWorkOrders();

  }, []);

  return (
    <>
  
  <div className="row py-2 start-0 bg-light">
                
                <div className="col-md-12 col-sm-12 mx-auto text-center">
                <div className="container-fluid z-2  ">

                <span className="btn btn-warning rounded-0 me-1">
                    <NavLink className="nav-link" smooth to="/case-manager/work-orders-active">
                        ACTIVE
                    </NavLink>
                </span>
                <span className="btn btn-warning rounded-0  me-1 ">
                    <NavLink className="nav-link" smooth to="/case-manager/work-orders-records-obtained">
                        RECORDS OBTAINED
                    </NavLink>
                </span>

                <span className="btn btn-success rounded-0  me-1 ">
                    <NavLink className="nav-link" smooth to="/case-manager/work-orders-closed">
                        CLOSED
                    </NavLink>
                </span>

                <span className="btn btn-warning rounded-0  ">
                    <NavLink className="nav-link" smooth to="/case-manager/work-orders-incomplete">
                        INCOMPLETE
                    </NavLink>
                </span>
            </div>
            </div>
            </div>


            <div className="row py-2 start-0  mx-auto ">
                
            <div className="col-md-6 col-sm-12  ">
                    <h3 className="text-dark my-0">CLOSED WORK ORDERS</h3>
                </div>

                <div className="col-md-6 col-sm-12 ps-3 text-end">
               
                <span className="btn btn-primary rounded-0 me-1">
                    <NavLink className="nav-link" smooth to="/case-manager/work-orders-new">
                        NEW
                    </NavLink>
                </span>
                <span className="btn btn-danger rounded-0  me-1 ">
                    <NavLink className="nav-link" smooth to="/case-manager/work-orders-search">
                        SEARCH
                    </NavLink>
                </span>
              
                </div>

                </div>

      {data &&


<div className="card border-4 border-dark rounded-1 card-success mb-4" >

<div className="card-body p-0" >
           
            <CustomTable columns={columns} data={data} />

          </div>
        </div>


      }
    </>

  );
};

export default Closed;